<template>
  <div class="w-100">
    <div v-if="title" class="atom-input--title">
      {{ title }}<label v-if="isAsterisk" class="atom-input--asterisk">*</label>
    </div>
    <b-input-group
      :class="{
        'invalid-border-input-password': type === 'password' && this.isError,
      }"
    >
      <b-input-group-prepend v-if="iconLeft" class="atom-input--icon-left">
        <span class="input-group-text" :class="inputBoxStyle"
          ><feather-icon :icon="iconLeft" :stroke="iconStrokeStyle"
        /></span>
      </b-input-group-prepend>

      <b-form-input
        v-model="inputValue"
        :class="[iconBorderStyle, inputBoxStyle]"
        :disabled="isDisable"
        :placeholder="placeholder"
        :type="type === 'password' ? passwordFieldType : type"
        :formatter="formatter"
        @keyup.enter="onKeyupEnter"
      ></b-form-input>
      <b-input-group-append v-if="type === 'password'" is-text>
        <feather-icon
          class="cursor-pointer"
          :icon="passwordToggleIcon"
          @click="togglePasswordVisibility"
        />
      </b-input-group-append>
      <b-input-group-append
        v-else-if="iconRight"
        class="atom-input--icon-right"
      >
        <span class="input-group-text" :class="inputBoxStyle"
          ><feather-icon :icon="iconRight" :stroke="iconStrokeStyle"
        /></span>
      </b-input-group-append>
    </b-input-group>
    <div v-if="isError && errorMessage" class="atom-input--error">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import {
  BInputGroup,
  BFormInput,
  BInputGroupPrepend,
  BInputGroupAppend,
} from "bootstrap-vue"
import { togglePasswordVisibility } from "@core/mixins/ui/forms"

export default {
  name: "AtomInput",
  components: {
    BFormInput,
    BInputGroup,
    BInputGroupPrepend,
    BInputGroupAppend,
  },
  mixins: [togglePasswordVisibility],
  props: {
    title: {
      type: String,
      required: false,
      default: "",
    },
    isDisable: {
      type: Boolean,
      required: false,
      default: false,
    },
    isError: {
      type: Boolean,
      required: false,
      default: false,
    },
    iconLeft: {
      type: String,
      required: false,
      default: "",
    },
    iconRight: {
      type: String,
      required: false,
      default: "",
    },
    placeholder: {
      type: String,
      required: false,
      default: "",
    },
    errorMessage: {
      type: String,
      required: false,
      default: "",
    },
    isAsterisk: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      required: false,
      default: "text", // "text", "number", "password", "email"
    },
    value: {
      type: [String, Number],
      required: false,
    },
    maxLength: {
      type: Number,
      required: false,
      default: null,
    },
    formatter: {
      type: Function,
      required: false,
      default: undefined,
    },
  },
  emits: ["input", "onKeyupEnter"],
  computed: {
    inputValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit("input", value)
      },
    },
    iconBorderStyle() {
      if (this.iconLeft && this.iconRight) {
        return "atom-input-box--borderless"
      } else if (this.iconLeft) {
        return "atom-input-box--no-left-border"
      } else if (this.iconRight || this.type === "password") {
        return "atom-input-box--no-right-border"
      } else {
        return ""
      }
    },
    iconStrokeStyle() {
      return this.Error ? "#EA5455" : "currentcolor"
    },
    inputBoxStyle() {
      if (this.isDisable) {
        return "atom-input--disable-background"
      } else if (this.isError) {
        return "is-invalid-border"
      } else {
        return ""
      }
    },
    passwordToggleIcon() {
      return this.passwordFieldType === "password" ? "EyeIcon" : "EyeOffIcon"
    },
  },
  watch: {
    inputValue: {
      deep: true,
      handler() {
        this.checkTextInput(this.inputValue)
      },
    },
  },
  methods: {
    checkTextInput(messages) {
      this.$nextTick(() => {
        if (!!this.maxLength && messages.length > this.maxLength) {
          this.inputValue = messages.slice(0, this.maxLength)
        }
      })
    },
    onKeyupEnter() {
      this.$emit("onKeyupEnter", this.inputValue)
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@core/scss/vue/pages/page-auth.scss";
.is-invalid-border {
  border-color: #ea5455;
}

.invalid-border-input-password .input-group-append .input-group-text {
  border-color: #ea5455;
}

.is-invalid-border:focus + .input-group-append .input-group-text {
  border-color: #7367f0;
}

.atom-input--title {
  color: #5e5873;
  font-size: 12px;
  margin-bottom: 5px;
  line-height: 1.5;
}
.atom-input--asterisk {
  color: #ea5455;
  font-size: 12px;
  margin-bottom: 0;
}

.atom-input--error {
  color: #ea5455;
  font-size: 12px;
  margin-top: 4px;
  line-height: 1.5;
}

.atom-input--icon-left {
  .input-group-text {
    border-right: none;
    padding-left: 1rem;
    padding-right: 0.1rem;
  }
}

.atom-input--icon-right {
  .input-group-text {
    border-left: none;
    padding-left: 1rem;
  }
}

.atom-input--disable-background {
  background-color: #efefef;
}

.atom-input-box--borderless {
  border-left: none;
  border-right: none;
}

.atom-input-box--no-left-border {
  border-left: none;
}

.atom-input-box--no-right-border {
  border-right: none;
}

::-ms-reveal {
  display: none;
}
</style>
